import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const AnnualDeaths = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução anual de óbitos'}
            horizontal={true}
            subtitles={chartData?.annualDeaths?.map((item) => item.description)}
            values={chartData?.annualDeaths?.map((item) => item.total  ||  0)}
            height={450}
        />
    );
};
